/**
 * E2E-Testlaeufe (docs/e2e/) setzen dieses Flag, damit Testtraffic nie im
 * GTM-Funnel landet. Eigene Datei, damit consent.ts und analytics.ts sich
 * nicht gegenseitig importieren muessen.
 */
export function isE2eTestSession(): boolean {
  try {
    return localStorage.getItem('fo-e2e-test') === '1';
  } catch {
    return false;
  }
}
